import React from 'react';
import './Footer.css';
import { GoPackage } from 'react-icons/go';
import { Ri24HoursFill } from 'react-icons/ri';
import { BiSupport } from 'react-icons/bi';


export default function Footer(){
    return (<div className="linha">
    <div className="coluna-25"><GoPackage className="icone3"/><ul/>PRONTA ENTREGA</div>
    <div className="coluna-25"><Ri24HoursFill className="icone3"/><ul/>ATENDIMENTO EMERGENCIAL</div>
    <div className="coluna-25"><BiSupport className="icone3"/><ul/>SUPORTE TÉCNICO</div>
  </div>)
}